<template>
    <div id="patients-portal-change-info">
        <MdTitleRegInfo
            v-if="$route.params.id"
            v-bind:RegistrationInfo="PatientTitle"
            v-bind:titlePrefix="$t('PPDbChangeInfo.Title')"
            v-bind:titleRef="'titleElementChangeInfo'"
            v-bind:patientCode="$route.params.id"
        />
        <MdTitle v-else v-bind:Text="$t('PPDbChangeInfo.Title')" />
        <div
            class="alert alert-fill-warning d-flex align-items-center m-3"
            role="alert"
            v-if="isReadOnly"
        >
            <i class="mdi mdi-alert-circle me-2" style="font-size: 1.5rem;"></i>
            <div class="flex-grow-1">
                <span>{{ $t('Shared.ReadOnlyPermission') }}</span>
            </div>
        </div>

        <b-row>
            <b-col sm="12" md="12">
                <div class="textlabel" :data-label="$t('Shared.SearchElements')">
                    <div class="input-group" dir="ltr">
                        <input
                            type="text"
                            class="form-control"
                            :dir="dirInput"
                            v-model="parameters.searchCriteria"
                            @keyup.enter="searchInfo"
                        />
                        <div class="input-group-append">
                            <MdButton
                                v-bind:Name="'btnsearchinput'"
                                v-bind:VariantProp="'btn btn-sm search-attached'"
                                v-bind:IconClass="'mdi mdi-magnify'"
                                v-on:click="searchInfo"
                            />
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>

        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('PPDbChangeInfo.RequestStatus')"
                    v-bind:Options="requestStatusOptions"
                    v-bind:ModelArray="requestStatusModel"
                    v-bind:FieldDescription="'text'"
                    v-bind:FieldCode="'value'"
                    :Input="changeRequestStatus"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdDateTime
                    :Label="$t('Shared.datefrom')"
                    :Model="parameters.requestDateFrom"
                    @input="parameters.requestDateFrom = $event"
                    :Id="'RequestDateFrom'"
                    :Type="'date'"
                    :isRequired="false"
                    :OnPressEnter="searchInfo"
                    :isConfirm="false"
                    :ReadOnly="false"
                    :isValid="isRequestDateFromValid"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdDateTime
                    :Label="$t('Shared.dateTo')"
                    :Model="parameters.requestDateTo"
                    @input="parameters.requestDateTo = $event"
                    :Id="'RequestDateTo'"
                    :Type="'date'"
                    :isRequired="false"
                    :OnPressEnter="searchInfo"
                    :isConfirm="false"
                    :ReadOnly="false"
                    :isValid="isRequestDateToValid"
                />
            </b-col>
            <b-col md="3" sm="12">
                <div class="text-md-right mt-3">
                    <button
                        type="button"
                        class="btn btn-primary btn-login mx-2"
                        v-on:click="searchInfo"
                    >
                        {{ $t('Shared.Search') }}
                    </button>
                </div>
            </b-col>
        </b-row>

        <MdTitle
            v-bind:Text="$t('Shared.SearchResult')"
            v-bind:isSubtitle="true"
            v-bind:Name="'T_TitleSearch'"
        />

        <b-row>
            <b-col class="col-12 mt-2">
                <MdTable
                    v-bind:fields="fields"
                    v-bind:items="items"
                    v-bind:totalRows="totalRows"
                    v-bind:showMessageIsEmpty="showMessageIsEmpty"
                    v-bind:currentPage="currentPage"
                    v-bind:perPage="perPage"
                    v-bind:pageOptions="pageOptions"
                    v-bind:VisibleEditIcon="!isReadOnly"
                    v-bind:FieldsDate="fieldsDateArr"
                    :editIconEvent="isReadOnly ? null : editRequestHandler"
                    :onRowSelected="onRowSelected"
                    :onFiltered="onFiltered"
                    :pageChanged="pageChanged"
                    :perPageFunction="perPageFunction"
                    :IsPatientPortalDashboard="true"
                    :isReadOnly="isReadOnly"
                />
            </b-col>
        </b-row>

        <PatientPortalChangeInfoDialog
            v-if="editDialogVisible"
            :visible="editDialogVisible"
            :item="selectedRequest"
            @change="onChangeRequest"
            @discard="onDiscardRequest"
            @undoDiscard="onUndoDiscardRequest"
            @close="closeEditDialog"
        />

        <div class="space-actions"></div>
        <div v-if="!$route.params.id" class="page-actions">
            <MdButton
                v-bind:Label="$t('Shared.Back')"
                v-bind:Name="'btnback'"
                v-bind:ClassProp="'secondary mx-2 btn-login'"
                v-on:click="goBack"
            />
        </div>

        <patient-portal-notify
            :visible.sync="notifyVisible"
            :patientCodeList="selectedPatientCodeList"
            :notifyType="notifyType"
            :notifyTemplateList="
                notifyType === 'email' ? notifyEmailTemplateList : notifyTextTemplateList
            "
        />
    </div>
</template>

<script>
import PatientsPortalBase from './patientsPortalBase.vue';
import EnumService from '@/services/enum.service';
import Utils from '@/common/utils';
import { EventBus } from '@/event-bus.js';
import PatientPortalsService from '@/services/patientportals.service';
import PatientPortalChangeInfoService from '@/services/patientPortalChangeInfo.service';
import { patientsPortalStore } from './patientsPortalStore';
import PatientPortalChangeInfoDialog from './dialogs/patientPortalChangeInfoDialog.vue';
import PatientPortalNotify from './dialogs/patientPortalNotify.vue';

export default {
    name: 'PatientsPortalChangeInfo',
    extends: PatientsPortalBase,
    components: { PatientPortalChangeInfoDialog, PatientPortalNotify },
    data() {
        return {
            RightMenuList: JSON.parse(JSON.stringify(EnumService.PatientsPortalSummaryItems)),
            items: [],
            totalRows: 0,
            pageOptions: [5, 10, 15],
            currentPage: 1,
            perPage: 10,
            fields: [
                {
                    key: 'requestDate',
                    sortable: true,
                    label: this.$t('PPDbChangeInfo.DateRequested'),
                    class: 'text-center',
                    formatter: value => {
                        return value ? Utils.formatterDateToString(value) : '';
                    }
                },
                {
                    key: 'firstNameNew',
                    sortable: true,
                    label: this.$t('Shared.PatientName'),
                    class: 'text-left',
                    formatter: (_value, _key, item) => {
                        return `${item.firstNameOld || ''} ${item.lastNameOld || ''}`.trim();
                    }
                },
                {
                    key: 'patientCode',
                    sortable: true,
                    label: this.$t('Shared.PatientCode'),
                    class: 'text-left'
                },
                {
                    key: 'changedByName',
                    sortable: true,
                    label: this.$t('PPDbChangeInfo.ChangedBy'),
                    class: 'text-left'
                },
                {
                    key: 'changedDate',
                    sortable: true,
                    label: this.$t('ActList.DateChanged'),
                    class: 'text-center',
                    formatter: value => {
                        return value ? Utils.formatterDateToString(value) : '';
                    }
                }
            ],
            fieldsDateArr: ['requestDate', 'changedDate'],
            showMessageIsEmpty: false,
            parameters: {
                searchCriteria: '',
                requestStatus: 'New',
                requestDateFrom: null,
                requestDateTo: null,
                changedDateFrom: null,
                changedDateTo: null
            },
            requestStatusOptions: [
                { value: null, text: this.$t('Shared.All') },
                { value: 'New', text: this.$t('Shared.New') },
                { value: 'Processed', text: this.$t('Shared.Processed') },
                { value: 'Discarded', text: this.$t('PPDbChangeInfo.Discarded') }
            ],
            requestStatusModel: { value: 'New', text: this.$t('Shared.New') },
            isRequestDateFromValid: true,
            isRequestDateToValid: true,
            isChangedDateFromValid: true,
            isChangedDateToValid: true,
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
            editDialogVisible: false,
            selectedRequest: null,
            isReadOnly: this.$store.state.isPatientPortalChangeInformationEHRReadOnly
        };
    },
    methods: {
        goBack() {
            this.$router.push({ name: 'patients-portal' });
        },

        changeRequestStatus(value) {
            this.parameters.requestStatus = value ? value.value : null;
            this.requestStatusModel = value || this.requestStatusOptions[0];
            this.searchInfo();
        },

        onRowSelected() {},
        onFiltered() {},

        editRequestHandler(item) {
            this.selectedRequest = item;
            this.editDialogVisible = true;
        },

        closeEditDialog() {
            this.editDialogVisible = false;
            this.selectedRequest = null;
        },

        async onChangeRequest(item) {
            try {
                const response = await PatientPortalChangeInfoService.update(item.id);
                if (response.status === 200 || response.status === 204) {
                    this.showMessage(
                        this.$t('Msg.Success'),
                        this.$t('Shared.SavedSuccessfully'),
                        'success'
                    );
                    this.closeEditDialog();
                    await this.listingAsync();
                }
            } catch (error) {
                this.showResponseErrorMessage(error);
            }
        },

        async onDiscardRequest(item) {
            try {
                const response = await PatientPortalChangeInfoService.discard(item.id, 'D');
                if (response.status === 200 || response.status === 204) {
                    this.showMessage(
                        this.$t('Msg.Success'),
                        this.$t('Shared.SavedSuccessfully'),
                        'success'
                    );
                    this.closeEditDialog();
                    await this.listingAsync();
                }
            } catch (error) {
                this.showResponseErrorMessage(error);
            }
        },

        async onUndoDiscardRequest(item) {
            try {
                const response = await PatientPortalChangeInfoService.discard(item.id, 'Y');
                if (response.status === 200 || response.status === 204) {
                    this.showMessage(
                        this.$t('Msg.Success'),
                        this.$t('Shared.SavedSuccessfully'),
                        'success'
                    );
                    this.closeEditDialog();
                    await this.listingAsync();
                }
            } catch (error) {
                this.showResponseErrorMessage(error);
            }
        },

        pageChanged(page) {
            this.currentPage = page;
            this.listingAsync();
        },

        perPageFunction(perPage) {
            this.perPage = perPage;
            this.currentPage = 1;
            this.listingAsync();
        },

        searchInfo() {
            this.currentPage = 1;
            this.listingAsync();
        },

        validateDates() {
            let valid = true;

            if (this.parameters.requestDateFrom && this.parameters.requestDateTo) {
                const result = Utils.validateDateRange(
                    this.parameters.requestDateFrom,
                    this.parameters.requestDateTo
                );
                if (!result.valid) {
                    this.isRequestDateToValid = !result.fields.includes('toDate');
                    this.isRequestDateFromValid = !result.fields.includes('fromDate');
                    this.showMessage(this.$tc('Msg.Error'), this.$t(result.message), 'error');
                    valid = false;
                }
            } else {
                this.isRequestDateFromValid =
                    !this.parameters.requestDateFrom ||
                    Utils.isValidDate(this.parameters.requestDateFrom);
                this.isRequestDateToValid =
                    !this.parameters.requestDateTo ||
                    Utils.isValidDate(this.parameters.requestDateTo);
                if (!this.isRequestDateFromValid || !this.isRequestDateToValid) {
                    valid = false;
                }
            }

            if (this.parameters.changedDateFrom && this.parameters.changedDateTo) {
                const result = Utils.validateDateRange(
                    this.parameters.changedDateFrom,
                    this.parameters.changedDateTo
                );
                if (!result.valid) {
                    this.isChangedDateToValid = !result.fields.includes('toDate');
                    this.isChangedDateFromValid = !result.fields.includes('fromDate');
                    this.showMessage(this.$tc('Msg.Error'), this.$t(result.message), 'error');
                    valid = false;
                }
            } else {
                this.isChangedDateFromValid =
                    !this.parameters.changedDateFrom ||
                    Utils.isValidDate(this.parameters.changedDateFrom);
                this.isChangedDateToValid =
                    !this.parameters.changedDateTo ||
                    Utils.isValidDate(this.parameters.changedDateTo);
                if (!this.isChangedDateFromValid || !this.isChangedDateToValid) {
                    valid = false;
                }
            }

            if (!valid) {
                this.showMessage(
                    this.$tc('Msg.Error'),
                    this.$t('Msg.CheckRedLabeledFields'),
                    'errorAutoHide'
                );
            }
            return valid;
        },

        async loadPatientTitle(patientCode) {
            const infoList = await this.getInfoTitle(patientCode);
            if (infoList && infoList.length > 0) {
                const { dob, firstname, lastname, age, ageFormatted } = infoList[0];
                if (ageFormatted) this.PatientTitle.ageFormatted = ageFormatted;
                if (dob) this.PatientTitle.dob = Utils.formatterDateToString(dob);
                if (age) this.PatientTitle.age = age;
                if (firstname) this.PatientTitle.fullName = `${firstname} ${lastname}`;
            }
        },

        async loadPortalPatient(patientCode) {
            const response = await PatientPortalsService.getAllDashboard({
                PageSize: 1,
                PageNumber: 1,
                PatientCodeList: [patientCode],
                status: null,
                portalStatus: null
            });
            if (response.status === 200 && response.data && response.data.length > 0) {
                this.selectedItems = response.data.filter(
                    x => x.patientCode.trim() === patientCode.trim()
                );
            }
        },

        enabledAllItems() {
            const item = this.selectedItems.length === 1 ? this.selectedItems[0] : null;
            this.RightMenuList.forEach(element => {
                let buttonEnabled = false;
                switch (element.value) {
                    case 'PPDB_CreateCredentials':
                        buttonEnabled =
                            item &&
                            item.portalStatus === 'Not Enrolled' &&
                            Utils.isNullOrEmptyString(item.userName) &&
                            !Utils.isNullOrEmptyString(item.email) &&
                            !!item.dob;
                        break;
                    /*
                    case 'PPDB_CreateAuthLogins':
                        buttonEnabled =
                            item &&
                            Utils.isNullOrEmptyString(item.userName) &&
                            !Utils.isNullOrEmptyString(item.email);
                        break;
                    case 'PPDB_CreateLogin':
                        buttonEnabled =
                            item &&
                            Utils.isNullOrEmptyString(item.userName) &&
                            !Utils.isNullOrEmptyString(item.email);
                        break;
                    */
                    case 'PPDB_ChangeUsername':
                    case 'PPDB_ChangePassword':
                        buttonEnabled = item && !Utils.isNullOrEmptyString(item.userName);
                        break;
                    case 'PPDB_PatientForms':
                    case 'PPDB_PatientContacts':
                    case 'PPDB_PatientClaims':
                    case 'PPDB_PatientInfo':
                    case 'PPDB_Summary':
                    case 'PPDB_ChangePatInfo':
                    case 'PPDB_Messages':
                    case 'PPDB_PatientList':
                        buttonEnabled = true;
                        break;
                    case 'PPDB_EmailToPatient':
                        buttonEnabled = this.isNotify('email');
                        break;
                    case 'PPDB_TextToPatient':
                        buttonEnabled = this.isNotify('text');
                        break;
                    default:
                        break;
                }
                element.ReadOnly = !buttonEnabled;
            });

            this.OptionsRightMenu.visible = false;
            this.OptionsRightMenu.btnPatientsPortalDashboardVisible = true;
            this.OptionsRightMenu.ItemsList = this.RightMenuList;
            this.OptionsRightMenu.active_el = this.getActiveElement();
            this.$emit('onMenuRightBarPatientsPortalDashboard', this.OptionsRightMenu);
        },

        async listingAsync() {
            if (!this.validateDates()) return;

            await PatientPortalChangeInfoService.getAll({
                PageSize: this.perPage,
                PageNumber: this.currentPage,
                PatientCodeList: this.$route.params.id ? [this.$route.params.id] : null,
                SearchCriteria: this.parameters.searchCriteria || null,
                RequestStatus: this.parameters.requestStatus,
                RequestDateFrom: this.parameters.requestDateFrom || null,
                RequestDateTo: this.parameters.requestDateTo || null,
                ChangedDateFrom: this.parameters.changedDateFrom || null,
                ChangedDateTo: this.parameters.changedDateTo || null,
                OrderBy: 'RequestDate'
            })
                .then(response => {
                    if (response.status === 200 && response.data) {
                        this.items = response.data;
                        const header = JSON.parse(response.headers['x-pagination']);
                        this.totalRows = header.TotalCount;
                    }
                    this.showMessageIsEmpty = this.totalRows === 0;
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        }
    },

    async mounted() {
        const patientCode = this.$route.params.id;

        if (!patientCode) {
            this.OptionsRightMenu.btnPatientsPortalDashboardVisible = false;
            this.$emit('onMenuRightBarPatientsPortalDashboard', this.OptionsRightMenu);
            await this.listingAsync();
            return;
        }

        await this.$nextTick();
        EventBus.$emit('loadMenu', patientCode);
        try {
            const stored = patientsPortalStore.selectedItem;
            if (stored && stored.patientCode.trim() === patientCode.trim()) {
                this.selectedItems = [stored];
                patientsPortalStore.selectedItem = null;
                await this.loadPatientTitle(patientCode);
            } else {
                await Promise.all([
                    this.loadPatientTitle(patientCode),
                    this.loadPortalPatient(patientCode)
                ]);
            }
        } catch (e) {
            // fall through to enabledAllItems with whatever data loaded
        }
        this.enabledAllItems();
        await this.listingAsync();
    }
};
</script>
